import {BusinessType} from 'web-angular-client';
import {DropdownItem} from '../interface/data/DropdownItem';

export class ConstantsUtil
{
    public static readonly PROVINCE_LIST: string[] = [
        'Eastern Cape',
        'Free State',
        'Gauteng',
        'KwaZulu-Natal',
        'Limpopo',
        'Mpumalanga',
        'Northern Cape',
        'North West',
        'Western Cape'
    ];

    public static readonly BUSINESS_TYPE_LIST: DropdownItem[] = [
        {label: 'Sole Proprietor', value: BusinessType.SOLE_PROPRIETOR},
        {label: 'CC', value: BusinessType.CLOSED_CORPORATION},
        {label: '(PTY) LTD', value: BusinessType.PTY},
        {label: 'Incorporated Company (Inc)', value: BusinessType.INCORPORATED_COMPANY_INC}
    ];

    public static readonly MULTI_PREMIUM_OPTIONS: DropdownItem[] =
        Array.from({length: 12}, (_, i) => ({value: i + 1}));

}
